// extracted by mini-css-extract-plugin
export default {"backdrop":"App_backdrop__7SF20"};